import { Component, ElementRef, ViewChild, Injector } from '@angular/core';
import { toObservable } from '@angular/core/rxjs-interop';
import { ConfirmationService } from 'primeng/api'; import { ActivatedRoute } from '@angular/router';
import { ConfGeraisService } from 'src/app/services/conf-gerais.service'; import { WidgetHelperService } from 'src/app/services/widget-helper.service';
import { Store } from 'src/app/models/store'; import { DomSanitizer, SafeResourceUrl } from '@angular/platform-browser';
import { Chips } from 'primeng/chips'; import { environment } from 'src/environments/environment';
import { ChangeDetectorRef, OnInit } from '@angular/core'; // src\app\layout\service\app.layout.service.ts
import { MessageService } from 'primeng/api'; //import { ColorScheme, MenuColorScheme, MenuMode } from '.src/app/layout/service/app.layout.service';
import { MediaUploadService } from 'src/app/services/media-upload.service'; import { lastValueFrom } from 'rxjs';
import { Observable, fromEvent } from 'rxjs'; import { ErrorHandlerService } from 'src/app/services/error-handler.service';
import { from, map } from 'rxjs';
import { tap, catchError, finalize, filter } from 'rxjs/operators';
import { ColorScheme } from 'src/app/layout/service/app.layout.service';
import { CountryService } from 'src/app/servicesApollo/country.service';
import { LayoutService } from 'src/app/layout/service/app.layout.service';
import {
  FormBuilder,
  FormGroup,
  Validators,
  FormArray,
  FormControl,
  ValidatorFn
} from '@angular/forms';
interface PhoneNumber {
  ddd: string;
  number: string;
}

@Component({
  selector: 'app-configurations',
  templateUrl: './configurations.component.html',
  styleUrls: ['./configurations.component.scss']
})
export class ConfigurationsComponent implements OnInit {
  storeName: string = '';
  storeDescription: string = '';
  urlStore: string = '';
  urlStoreBefore: string = '';
  address: string = '';
  nro: string = '';
  neighborhood: string = '';
  complement: string = '';
  city: string = '';
  country: any;
  state: string = '';
  zipcode: string = '';
  email: string = '';
  phoneDDD: string = '';
  phone: string = '';
  whatsDDD: string = '';
  whatsapp: string = '';
  selectedState: any;
  page: boolean = true;
  btnSave: boolean = true;
  manutantionMode: boolean = false;
  creatorsScreen: boolean = false;
  localhost: boolean = false;
  logoPreviewUrl: any = null;
  faviconPreviewUrl: any = null;
  logoSelected: boolean = false;
  saveBtnForm: boolean = false;
  primaryColor: string = '#00FF00';
  secondaryColor: string = '#FF0000';
  pageOptions: any[] = [];
  states: any[] = [];
  valuesDoms: string[] | undefined;
  isApp: boolean = false;
  isCol4: boolean = false;
  aspectRatio?: any;
  widget_share: string = '';
  copiarWidget() { if (this.widget_share) { this.widgetHelperService.copiarTextoParaClipboard(this.widget_share.toString()); } }
  resolutions: { label: string; value: { width: number; height: number } }[] = [];
  iframeUrl: SafeResourceUrl | null = null;

  deviceOptions = [{ icon: 'pi pi-mobile', name: 'Desktop', value: 1 }, { icon: 'pi pi-mobile rotate-90', name: 'Mobile', value: 2 },];
  selectedDevice = { icon: 'pi pi-desktop', name: 'Desktop', value: 1 };
  previewImagePath: string = '';
  private readonly previewBaseUrl = 'https://krabo163508-dev.s3.sa-east-1.amazonaws.com/public/uploads/images/ss';
  private readonly previewKeyMap: Record<string, string> = {
    '540x960': '9_16',
    '960x540': '16-9',
    '540x540': '1_1'
  };
  onDeviceChange(): void {
    // Apenas força atualização do preview com a resolução atual + novo tipo de dispositivo
    this.onResolutionChange(this.selectedResolution);
  }

  onResolutionChange(resolution: { width: number; height: number }) {
    if (!resolution) return;

    this.height = resolution.height;
    this.aspectRatio = `${resolution.width} / ${resolution.height}`;

    const domainStore = localStorage.getItem('domain_store');
    let loja = '';

    if (domainStore) {
      const match = domainStore.match(/^([^\.]+)\./);
      loja = match ? match[1] : '';
    }

    // constrói caminho da imagem baseado em resolução e device
    const deviceType = this.selectedDevice?.value === 2 ? 'mobile' : 'desktop';
    this.previewImagePath = this.getPreviewImageUrl(resolution, deviceType);

    // iframe embed ainda disponível (caso queira usar em outro contexto)
    this.widget_share = `<iframe src="${environment.frontendUrl}/${loja}" frameborder="0" width="${resolution.width}px" height="${resolution.height}px"></iframe>`;
  }

  private getPreviewImageUrl(resolution: { width: number; height: number }, device: 'mobile' | 'desktop'): string {
    const key = `${resolution.width}x${resolution.height}`;
    const folder = this.previewKeyMap[key];
    if (!folder) {
      return '';
    }
    return `${this.previewBaseUrl}/${folder}-${device}`;
  }

  getAspectRatioStyles(): { [key: string]: string } {
    if (!this.aspectRatio) return {};

    const ratioParts = this.aspectRatio.split('/');
    if (ratioParts.length !== 2) return {};

    const width = parseFloat(ratioParts[0]);
    const height = parseFloat(ratioParts[1]);

    if (isNaN(width) || isNaN(height)) return {};

    const styles: { [key: string]: string } = {
      'aspect-ratio': `${width} / ${height}`,
      'max-height': '88vh'
    };

    // Só aplicar width 100% se for Desktop
    if (this.selectedDevice?.value === 1) {
      styles['width'] = '100%';
    }

    return styles;
  }


  private setIframeUrl(): void {
    let domainStore = localStorage.getItem('domain_store'); // Obtém o valor do localStorage
    if (!domainStore) {
      // Se não encontrar 'domain_store', tenta buscar o item 'store' no localStorage
      const storeInfoJSON = localStorage.getItem('store');

      if (storeInfoJSON) {
        try {
          const storeInfo = JSON.parse(storeInfoJSON); // Converte a string JSON para objeto
          domainStore = storeInfo.domain_store; // Extrai o 'domain_store' do objeto
        } catch (error) {
          console.error('Erro ao parsear o item store do localStorage:', error);
        }
      }
    }
    if (domainStore) {
      const storeName = domainStore.split('.')[0]; // Extração do subdomínio (antes do primeiro ponto)
      const unsafeUrl = `https://app.slicksell.com.br//${storeName}`; // Constrói o URL do iframe
      this.iframeUrl = this.sanitizer.bypassSecurityTrustResourceUrl(unsafeUrl); // Sanitiza o URL
    } else {
      console.warn('domain_store não encontrado no localStorage.');
    }
  }
  constructor(
    private confirmationService: ConfirmationService,
    private countryService: CountryService, private errorHandler: ErrorHandlerService,
    private sanitizer: DomSanitizer, private widgetHelperService: WidgetHelperService,
    private configService: ConfGeraisService,
    public fb: FormBuilder,
    private route: ActivatedRoute,
    private messageService: MessageService,
    private cdr: ChangeDetectorRef,
    public layoutService: LayoutService,
    private injector: Injector,
    private mediaUploadService: MediaUploadService
  ) {
    this.issueForm = this.fb.group({
      // defina os controles do formulário aqui
      // exemplo: 'name': ['']
    });
  }

  extractPhoneNumber(phoneFull: string): PhoneNumber {
    const cleanedPhone = phoneFull.replace(/\D/g, ''); // Remove todos os caracteres não numéricos, incluindo espaços
    const ddd = cleanedPhone.substring(0, 2); // Extrai os dois primeiros dígitos para o DDD
    const number = cleanedPhone.substring(2); // O restante é o número

    return { ddd, number };
  }
  updateZipCode(event: Event) {
    const value = (event.target as HTMLInputElement).value;
    this.zipcode = value.replace(/[^0-9]/g, '');
  }
  filterNonNumeric(event: KeyboardEvent) {
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
  filterSpecialChars(event: KeyboardEvent) {
    // Permite apenas letras (maiúsculas e minúsculas), números e espaço
    if (!/^[a-zA-Z0-9 ]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  filterSpecialCharsUrl(event: KeyboardEvent) {
    // Permite apenas letras (maiúsculas e minúsculas), números e traços
    if (!/^[a-zA-Z0-9-]$/.test(event.key)) {
      event.preventDefault();
    }
  }
  filterSpecialCharsUrlSite(ev: KeyboardEvent) {
    const key = ev.key;

    // permite letras, números, hífen e ponto
    const validChar = /^[a-zA-Z0-9.-]$/.test(key);
    if (!validChar) {
      ev.preventDefault();
      return;
    }

    // impede que o usuário tente digitar 'https' ou 'http'
    const current = (ev.target as HTMLInputElement).value + key;
    if (/^https?:\/\//i.test(current)) {
      ev.preventDefault();
    }
  }
  errorUrlSite:boolean=false;
  urlSiteMessage?:string;
  validateSiteDomain(): void {
    const value = (this.store_site || '').trim();

    // bloqueia se o valor começa com protocolo
    if (/^https?:\/\//i.test(value)) {
      this.errorUrlSite = true;
      this.urlSiteMessage = 'Não inclua "https://" ou "http://" no início.';
      return;
    }

    // valida formato de domínio simples
    const domainRegex = /^(?!-)[A-Za-z0-9-]+(\.[A-Za-z0-9-]+)+$/;
    if (!domainRegex.test(value)) {
      this.errorUrlSite = true;
      this.urlSiteMessage = 'Digite um domínio válido (ex: loja.com ou loja.minhamarca.com.br).';
      return;
    }

    // se passou, limpa erro
    this.errorUrlSite = false;
    this.urlSiteMessage = '';
  }


  // antigo
  handleManualLogoUpload(event: Event) {
    const input = event.target as HTMLInputElement;
    if (input.files && input.files.length > 0) {
      this.onLogoSelect({ files: [input.files[0]] });
    }
  }
  // novo
  showRequiredError = false;
  // novo acima


  cancelButton() {
    this.displaySidebar = false;
    // Cache-first com ETag (src/app/core/http-cache).
    const dadosLojaResource = this.configService.getDadosLojaPorIdRevalidated();

    toObservable(dadosLojaResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {
        this.storeName = res[0].store_name || '';
        this.storeDescription = res[0].store_description || '';
        this.urlStore = res[0].store_link_subdomain ? res[0].store_link_subdomain.split(".")[0] : '';
        this.address = res[0].store_street || '';
        this.nro = res[0].store_number || '';
        this.neighborhood = res[0].store_district || '';
        this.complement = res[0].store_complement || '';
        this.city = res[0].store_city || '';
        this.country = this.countries.find(country => country.name === res[0].store_country);
        // this.primaryColor = res[0].color_primary || '#00FF00'; // Valor padrão amarelo
        // this.secondaryColor = res[0].color_secondary || '#FF0000'; // Valor padrão vermelho
        this.email = res[0].support_email || '';
        this.zipcode = res[0].store_zip_code || '';
        this.manutantionMode = (res[0].maintenence_status == null || res[0].maintenence_status == 0) ? false : true;


        // Trata o telefone e o WhatsApp
        const phoneData = this.extractPhoneNumber((res[0].support_phone_number || '').replace(/\D/g, ''));
        this.phoneDDD = phoneData.ddd;
        this.phone = phoneData.number;

        const whatsappData = this.extractPhoneNumber((res[0].support_whatsapp || '').replace(/\D/g, ''));
        this.whatsDDD = whatsappData.ddd;
        this.whatsapp = whatsappData.number;
    });

    toObservable(dadosLojaResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null)
    ).subscribe(err => {
        console.error('Failed to set meta tags', err);
    });


    this.getConfigs();
  }
  issueForm?: FormGroup;
  uploadFile(file: File): Observable<string> {
    const storeId = localStorage.getItem('ss_SelectedStoreId') || '';
    return from(this.mediaUploadService.uploadForStore(file, storeId, 'store_identity')).pipe(
      map(({ url }) => url)
    );
  }
  selectedFileLogo: File | null = null;
  selectedFileFavicon: File | null = null;
  urlLogo: string = "";
  saveBtn3() {
    this.issueForm = this.fb.group({
      "store_link_subdomain": this.urlStore + '.slicksell.com.br'
    });



    this.configService.updateUrlLoja(this.issueForm.value).subscribe({
      next: (resp) => {
        this.saveBtnForm = false;
        localStorage.setItem('domain_store', this.urlStore + '.slicksell.com.br');
        localStorage.setItem('store_name', this.urlStore);
        this.btnSave = true;
        this.form3 = false;
        this.displaySidebar = false;
        // Exiba uma mensagem de sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'URL salva',
          detail: 'A URL da loja foi salva com sucesso!'
        });

        const storeDataStr = localStorage.getItem('store_data');
        if (storeDataStr) {
          try {
            const storeData = JSON.parse(storeDataStr);
            storeData.store_domain = this.urlStore + '.slicksell.com.br';
            localStorage.setItem('store_data', JSON.stringify(storeData));
          } catch (e) {
            console.error('Erro ao atualizar store_domain no localStorage:', e);
          }
        }
      },
      error: (error) => {
        this.form3 = false;
        let message = '';
        this.saveBtnForm = false;
        this.btnSave = true;
        console.error('Error response', error);


        if (error.status === 400 || error.status === 403 || error.status === 401) {
          message = error.error.message;
        } else if (error.status === 500) {
          message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
        } else if (error.status !== 404) {
          message = error.error.message;
        }
        this.errorURL = true;

        if (message) {
          this.showErrorDialog(message);
        }
      }
    });
  }
  logoTmp: string = "";
  faviconTmp: string = "";
  hasFaviconTmp: boolean = false;
  hasLogoTmp: boolean = false;

  // Helper: sobe e seta variáveis corretas
  private async uploadAndSet(file: File, kind: 'logo' | 'favicon' | 'wallpaper'): Promise<void> {
    const url = await lastValueFrom(this.uploadFile(file));
    const cleanUrl = url.split('?')[0];

    if (kind === 'logo') {
      this.logoTmp = cleanUrl;
      this.hasLogoTmp = true;
    } else if (kind === 'favicon') {
      this.faviconTmp = cleanUrl;
      this.hasFaviconTmp = true;
    } else {
      this.wallpaperTmp = cleanUrl;
      this.hasWallpaperTmp = true;
    }
  }
  async saveBtn2() {
    try {
      // Desabilite botões/mostre loading se desejar
      // this.saveBtnForm = true;

      const uploads: Promise<void>[] = [];

      if (this.selectedFileLogo) {
        uploads.push(this.uploadAndSet(this.selectedFileLogo, 'logo'));
      }
      if (this.selectedFileFavicon) {
        uploads.push(this.uploadAndSet(this.selectedFileFavicon, 'favicon'));
      }
      if (this.selectedFileWallpaper) {
        uploads.push(this.uploadAndSet(this.selectedFileWallpaper, 'wallpaper'));
      }

      // Sobe tudo em paralelo; espere concluir
      if (uploads.length) {
        await Promise.all(uploads);
      }

      // Agora salva as configurações com as URLs definitivas
      this.updateConfigurations();
    } catch (err) {
      console.error('Erro ao salvar (upload/config):', err);
      // trate UI/estado aqui se precisar
      // this.saveBtnForm = false;
    }
  }

  updateConfigurations() {
    const valoresString = JSON.stringify(this.valuesDoms);
    this.issueForm = this.fb.group({
      "dominios":
      {
        "key": "whitelist_domains",
        "value": valoresString,
      },
      "localhost":
      {
        "key": 'localhost_any',
        "value": this.localhost ? "1" : "0",
      },
      "logo":
      {
        "key": 'logo',
        "value": this.hasLogoTmp ? this.logoTmp : this.logoPreviewUrl,
      }
      ,
      "favicon":
      {
        "key": 'favicon',
        "value": this.hasFaviconTmp ? this.faviconTmp : this.faviconPreviewUrl,
      },
      "store_wallpaper": {
        "key": 'store_wallpaper',
        "value": this.hasWallpaperTmp ? this.wallpaperTmp : this.wallpaperPreviewUrl,
      },
      "color1":
      {
        "key": 'Background Color',
        "value": this.primaryColor,
      },
      "color2":
      {
        "key": 'Background Font Color',
        "value": this.secondaryColor,
      },
      "push_news_and_offers":
      {
        "key": 'push_news_and_offers',
        "value": this.push_news_and_offers ? "1" : "0",
      },
      "push_slick_comment":
      {
        "key": 'push_slick_comment',
        "value": this.push_slick_comment ? "1" : "0",
      },
      "push_account_limits":
      {
        "key": 'push_account_limits',
        "value": this.push_account_limits ? "1" : "0",
      },
      "store_site":
      {
        "key": 'store_site',
        "value": this.store_site,
      },
      "creators_screen":
      {
        "key": 'creators_screen',
        "value": this.creatorsScreen ? "1" : "0",
      }
    });
    this.configService.updateDadosLojaConfig(this.issueForm.value).subscribe({
      next: (resp) => {
        this.saveBtnForm = false;
        this.btnSave = true;
        this.form2 = false;
        this.hasFaviconTmp = false;
        this.hasLogoTmp = false;
        this.displaySidebar = false;
        // Exiba uma mensagem de sucesso
        this.messageService.add({
          severity: 'success',
          summary: 'Configurações Salvas',
          detail: 'As configurações foram salvas com sucesso!'
        });
      },
      error: (error) => {
        this.form2 = false;
        let message = '';
        this.saveBtnForm = false;
        this.btnSave = true;
        this.errorHandler.handle(error, message);
      }
    });
  }
  saveBtn() {
    if (this.errorName) {
      this.messageService.add({
        severity: 'error',
        summary: 'Erro',
        detail: 'O nome da loja contém erros!'
      });

      this.displaySidebar = false;
      return;
    }
    this.saveBtnForm = true;
    if (this.form1) {
      this.issueForm = this.fb.group({
        "store_name": this.storeName,
        "store_description": this.storeDescription,
        "support_email": this.email,
        "support_phone_number": this.phoneDDD + ' ' + this.phone,
        "support_whatsapp": this.whatsDDD + ' ' + this.whatsapp,
        "support_whatsapp_status": 0,
        "metadata_object_id": null,
        "store_zip_code": this.zipcode,
        "zipcode": null,
        "store_country": this.country?.name || '',
        "store_street": this.address,
        "store_number": this.nro,
        "store_district": this.neighborhood,
        "store_city": this.city,
        "store_uf": this.selectedState.value,
        "store_complement": this.complement,
        "show_address": 1,
        "maintenence_status": this.manutantionMode == true ? 1 : 0,
        "status": 1
      });
      this.configService.updateDadosLoja(this.issueForm.value).subscribe({
        next: (resp) => {
          this.saveBtnForm = false;
          this.btnSave = true;
          this.form1 = false;
          this.displaySidebar = false;
          // Exiba uma mensagem de sucesso
          this.messageService.add({
            severity: 'success',
            summary: 'Dados Salvos',
            detail: 'Os dados foram salvos com sucesso!'
          });

          const storeDataStr = localStorage.getItem('store_data');
          if (storeDataStr) {
            try {
              const storeData = JSON.parse(storeDataStr);
              storeData.store_name = this.storeName;
              localStorage.setItem('store_data', JSON.stringify(storeData));
            } catch (e) {
              console.error('Erro ao atualizar store_name no localStorage:', e);
            }
          }
        },
        error: (error) => {
          this.form1 = false;
          let message = '';
          this.saveBtnForm = false;
          this.btnSave = true;
          console.error('Error response', error);
          if (error.status === 400 || error.status === 403 || error.status === 401) {
            message = error.error.message;
          } else if (error.status === 500) {
            message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
          } else if (error.status !== 404) {
            message = error.error.message;
          }

          if (message) {
            this.showErrorDialog(message);
          }

        }
      });
    }
    if (this.form2) {
      this.saveBtn2();
    }
    if (this.form3) {
      this.saveBtn3();
    }
  }
  displaySidebar: boolean = true;
  countries: any[] = [];
  manageOverlay() {
    const overlays = document.querySelectorAll('.p-component-overlay');
    const overlayEnters = document.querySelectorAll('.p-component-overlay-enter');

    overlays.forEach((overlay: Element) => {
      (overlay as HTMLElement).style.display = 'none';
    });

    overlayEnters.forEach((overlayEnter: Element) => {
      (overlayEnter as HTMLElement).style.display = 'none';
    });

    this.cdr.detectChanges();
  }
  limitPhoneLength(event: Event, maxLength: number): void {
    const input = event.target as HTMLInputElement;
    if (input.value.length > maxLength) {
      input.value = input.value.slice(0, maxLength);
    }
  }
  toggleSidebar() {
    this.displaySidebar = false;
    setTimeout(() => {
      this.manageOverlay();
    }, 500);
  }
  toggleSidebar2() {
    this.displaySidebar = false;
    setTimeout(() => {
      this.manageOverlay();
    }, 10);
  }

  @ViewChild('domainsContainer') domainsContainer!: ElementRef;
  @ViewChild('chipsComponent') chipsComponent!: Chips;
  displayAguarde: boolean = false;
  selectedResolution: any;
  store_id?: string;
  height?: number;


  ngOnInit() { // primaryColor
    this.setIframeUrl()
    const selectedStoreId = localStorage.getItem('ss_SelectedStoreId');
    if (selectedStoreId) {
      this.store_id = selectedStoreId;
    }
    this.resolutions = this.widgetHelperService.getResolutions();
    const defaultResolution = this.resolutions.find(
      r => r.label.startsWith('9:16')
    );

    if (defaultResolution) {
      this.selectedResolution = defaultResolution.value;
      this.onResolutionChange(this.selectedResolution);
    }
    this.selectedDevice = this.deviceOptions[0];
    let loja: string = '';
    const domainStore = localStorage.getItem('domain_store'); // Obtém o valor do localStorage

    if (domainStore) {
      // Extrai o subdomínio (parte antes do primeiro ponto)
      const match = domainStore.match(/^([^\.]+)\./);
      loja = match ? match[1] : ''; // Se o subdomínio for encontrado, use-o, caso contrário, mantenha vazio
    }
    this.widget_share = `<iframe src="${environment.frontendUrl}/${loja}" frameborder="0" width="100px" height="100px"></iframe>`;
    this.toggleSidebar();
    this.countryService.getCountries().then(countries => {
      this.countries = countries;
    });
    this.displayAguarde = true;
    // Cache-first com ETag.
    const dadosLojaInitResource = this.configService.getDadosLojaPorIdRevalidated();

    toObservable(dadosLojaInitResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {
        this.storeName = res[0].store_name || '';
        this.storeDescription = res[0].store_description || '';
        this.urlStore = res[0].store_link_subdomain ? res[0].store_link_subdomain.split(".")[0] : '';

        this.urlStoreBefore = this.urlStore;

        this.address = res[0].store_street || '';
        this.nro = res[0].store_number || '';
        this.selectedState = { label: res[0].store_uf || 'SP', value: res[0].store_uf || 'SP' };;
        this.cdr.detectChanges();
        this.neighborhood = res[0].store_district || '';
        this.complement = res[0].store_complement || '';
        this.city = res[0].store_city || '';
        this.country = this.countries.find(country => country.name === res[0].store_country);

        this.email = res[0].support_email || '';
        this.zipcode = res[0].store_zip_code || '';
        this.manutantionMode = (res[0].maintenence_status == null || res[0].maintenence_status == 0) ? false : true;


        // Trata o telefone e o WhatsApp
        const phoneData = this.extractPhoneNumber((res[0].support_phone_number || '').replace(/\D/g, ''));
        this.phoneDDD = phoneData.ddd;
        this.phone = phoneData.number;

        const whatsappData = this.extractPhoneNumber((res[0].support_whatsapp || '').replace(/\D/g, ''));
        this.whatsDDD = whatsappData.ddd;
        this.whatsapp = whatsappData.number;


        this.displayAguarde = false;
    });

    toObservable(dadosLojaInitResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null)
    ).subscribe(err => {
        this.displayAguarde = false;
        console.error('Failed to set meta tags', err);
    });


    /// exibir imagem e logo
    this.getConfigs();

    this.pageOptions = [
      { name: 'Geral', value: 1 },
      { name: 'Atendimento', value: 2 },
      { name: 'Integrações', value: 3 },
    ];
    this.pageConfigs = this.pageOptions[0];

    //////////////
    this.route.queryParams.subscribe((params) => {
      const tab = params['tab'];
      const focus = params['focus'];

      // Configura a aba ativa
      if (tab === 'integrations') {
        this.pageConfigs = this.pageOptions[2];
        this.activeOption = 3;

        // Foca em "Domínios Permitidos" se solicitado
        if (focus === 'domains') {
          setTimeout(() => {
            // Rola até o container principal
            if (this.domainsContainer) {
              this.domainsContainer.nativeElement.scrollIntoView({ behavior: 'smooth', block: 'center' });
            }

            // Encontra o campo de input interno do p-chips e aplica o foco
            const inputElement = this.chipsComponent.el.nativeElement.querySelector('input');
            if (inputElement) {
              inputElement.focus();
            }
          }, 100);
        }
      }
    });
    //////////////
    this.states = [
      { label: 'AC', value: 'AC' },
      { label: 'AL', value: 'AL' },
      { label: 'AP', value: 'AP' },
      { label: 'AM', value: 'AM' },
      { label: 'BA', value: 'BA' },
      { label: 'CE', value: 'CE' },
      { label: 'DF', value: 'DF' },
      { label: 'ES', value: 'ES' },
      { label: 'GO', value: 'GO' },
      { label: 'MA', value: 'MA' },
      { label: 'MT', value: 'MT' },
      { label: 'MS', value: 'MS' },
      { label: 'MG', value: 'MG' },
      { label: 'PA', value: 'PA' },
      { label: 'PB', value: 'PB' },
      { label: 'PR', value: 'PR' },
      { label: 'PE', value: 'PE' },
      { label: 'PI', value: 'PI' },
      { label: 'RJ', value: 'RJ' },
      { label: 'RN', value: 'RN' },
      { label: 'RS', value: 'RS' },
      { label: 'RO', value: 'RO' },
      { label: 'RR', value: 'RR' },
      { label: 'SC', value: 'SC' },
      { label: 'SP', value: 'SP' },
      { label: 'SE', value: 'SE' },
      { label: 'TO', value: 'TO' }
    ];



    const accessToken = localStorage.getItem('viewMode');
    if (accessToken == 'dark') {
      this.darkMode = true;
    }
  }

  wallpaper?: string;
  store_site?: string;
  getConfigs() {
    // Cache-first com ETag.
    const configsResource = this.configService.getConfigsLojaPorIdRevalidated();

    toObservable(configsResource.data, { injector: this.injector }).pipe(
      filter((res): res is any => res !== null)
    ).subscribe(res => {

        // Inicializa as variáveis com valores padrão ou mantém vazias wallpaper
        this.primaryColor = '';
        this.secondaryColor = '';
        this.faviconPreviewUrl = '';
        this.logoPreviewUrl = '';
        this.store_site = '';

        // Itera sobre o array de configurações para encontrar os valores necessários
        res.forEach((config: any) => {
          if (config.key === 'Background Color') {
            this.primaryColor = config.value;
          } else if (config.key === 'Background Font Color') {
            this.secondaryColor = config.value;
          } else if (config.key === 'store_wallpaper') {
            this.wallpaperPreviewUrl = config.value || null;
            this.hasWallpaperTmp = false;
            this.wallpaperTmp = null;
            this.wallpaperPreviewUrl = config.value;
          } else if (config.key === 'favicon') {
            this.faviconPreviewUrl = config.value;
          } else if (config.key === 'store_site') {
            this.store_site = config.value;
          } else if (config.key === 'logo') {
            this.logoPreviewUrl = config.value;
          } else if (config.key === 'whitelist_domains') {
            try {
              const parsedValue = JSON.parse(config.value);
              if (Array.isArray(parsedValue)) {
                this.valuesDoms = parsedValue;
                this.showClearDoms = parsedValue.length > 0;
              } else {
                this.valuesDoms = []; // Define como array vazio se não for um array
                //console.error('Expected an array for whitelist_domains, received:', parsedValue);
              }
            } catch (error) {
              console.error('Error parsing whitelist_domains:', error);
              this.valuesDoms = []; // Caso a análise falhe
            }
          } else if (config.key === 'localhost_any') {
            this.localhost = config.value == "1" ? true : false;
          } else if (config.key === 'push_news_and_offers') {
            this.push_news_and_offers = config.value == "1" ? true : false;
          } else if (config.key === 'push_slick_comment') {
            this.push_slick_comment = config.value == "1" ? true : false;
          } else if (config.key === 'push_account_limits') {
            this.push_account_limits = config.value == "1" ? true : false;
          } else if (config.key === 'creators_screen') {
            this.creatorsScreen = config.value == "1" ? true : false;
          }

        });
    });

    toObservable(configsResource.error, { injector: this.injector }).pipe(
      filter((err): err is any => err !== null)
    ).subscribe(err => {
        console.error('Failed to set meta tags', err);
    });
  }
  darkMode: boolean = false;
  toggleTheme(): void {
    // Determina o novo esquema com base no estado do switch const accessToken = localStorage.getItem('access_token');
    const newScheme = this.darkMode ? 'dark' : 'light';
    localStorage.setItem('viewMode', newScheme);
    this.changeColorScheme(newScheme as ColorScheme);
  }

  changeColorScheme(colorScheme: ColorScheme): void {
    const themeLink = document.getElementById('theme-link') as HTMLLinkElement;
    if (themeLink) {
      const themeLinkHref = themeLink.getAttribute('href');
      const currentColorScheme = 'theme-' + this.layoutService.config.colorScheme;
      const newColorScheme = 'theme-' + colorScheme;
      const newHref = themeLinkHref!.replace(currentColorScheme, newColorScheme);
      this.replaceThemeLink(newHref, () => {
        this.layoutService.config.colorScheme = colorScheme;
        this.layoutService.onConfigUpdate();
      });
    } else {
      console.error('Theme link element not found!');
    }
  }

  replaceThemeLink(href: string, onComplete: () => void): void {
    const id = 'theme-link';
    const themeLink = document.getElementById(id) as HTMLLinkElement;
    const cloneLinkElement = themeLink.cloneNode(true) as HTMLLinkElement;

    cloneLinkElement.setAttribute('href', href);
    cloneLinkElement.setAttribute('id', id + '-clone');

    themeLink.parentNode!.insertBefore(cloneLinkElement, themeLink.nextSibling);

    cloneLinkElement.onload = () => {
      themeLink.remove();
      cloneLinkElement.setAttribute('id', id);
      onComplete();
    };
  }

  push_news_and_offers: boolean = true;
  push_slick_comment: boolean = true;
  push_account_limits: boolean = true;
  onChangePushNews() {
    this.displaySidebar = true;
    this.form2 = true;
    this.btnSave = false;
  }

  onChangePushComment() {
    this.displaySidebar = true;
    this.form2 = true;
    this.btnSave = false;
  }

  onChangePushLimits() {
    this.displaySidebar = true;
    this.form2 = true;
    this.btnSave = false;
  }

  pageConfigs?: any;
  activeOption: number = 1;
  onChangeSource: string = '';
  selecionarOpcao(opcao: number): void {
    this.onChangeSource = 'selectButton';
    this.activeOption = opcao;
  }

  changePage() {

  }
  onStateChange() {

  }
  erroTamanhoImagem: boolean = false;
  erroTipoImagem: boolean = false;
  onLogoSelect(event: any): void {
    this.erroTamanhoImagem = false;
    this.erroTipoImagem = false;
    this.form2 = true;
    if (event.files && event.files.length > 0) {
      this.selectedFileLogo = event.files[0]; // Atribuir o arquivo selecionado à variável selectedFile

      // Verificar o tamanho do arquivo (máximo 1MB)
      if (this.selectedFileLogo && this.selectedFileLogo.size > 1048576) {
        this.erroTamanhoImagem = true;
        this.selectedFileLogo = null;
        this.logoPreviewUrl = false;
        return;
      }

      // Verificar o tipo do arquivo (webp, png, jpg, jpeg)
      const fileType = this.selectedFileLogo?.type;
      if (fileType && !['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'].includes(fileType)) {
        this.erroTipoImagem = true;
        this.selectedFileLogo = null;
        this.logoPreviewUrl = false;
        return;
      }

      if (this.selectedFileLogo) { // Verifica se realmente existe um arquivo antes de prosseguir
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.logoPreviewUrl = e.target.result; // Atribui a URL da imagem para visualização
          this.checkSaveBtn();
          this.form2 = true;
          this.displaySidebar = true;
        };
        //this.toggleSidebar2();
        reader.readAsDataURL(this.selectedFileLogo);
      }
    } else {
      this.selectedFileLogo = null; // Resetar selectedFile se nenhum arquivo for selecionado
      this.logoPreviewUrl = null;
    }
  }
  // onLogoSelect(event: any): void {
  //   this.erroTamanhoImagem = false;
  //   this.erroTipoImagem = false;
  //   this.form2 = true;
  //   if (event.files && event.files.length > 0) {
  //     this.selectedFileLogo = event.files[0]; // Atribuir o arquivo selecionado à variável selectedFile

  //     // Verificar o tamanho do arquivo (máximo 1MB)
  //     if (this.selectedFileLogo && this.selectedFileLogo.size > 1048576) {
  //       this.erroTamanhoImagem = true;
  //       this.selectedFileLogo = null;
  //       this.logoPreviewUrl = null;
  //       return;
  //     }

  //     // Verificar o tipo do arquivo (webp, png, jpg, jpeg)
  //     const fileType = this.selectedFileLogo?.type;
  //     if (fileType && !['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'].includes(fileType)) {
  //       this.erroTipoImagem = true;
  //       this.selectedFileLogo = null;
  //       this.logoPreviewUrl = null;
  //       return;
  //     }

  //     if (this.selectedFileLogo) { // Verifica se realmente existe um arquivo antes de prosseguir
  //       const reader = new FileReader();
  //       reader.onload = (e: any) => {
  //         this.logoPreviewUrl = e.target.result; // Atribui a URL da imagem para visualização
  //         this.checkSaveBtn();
  //         this.form2 = true;
  //         this.displaySidebar = true;
  //       };
  //       //this.toggleSidebar2();
  //       reader.readAsDataURL(this.selectedFileLogo);
  //     }
  //   } else {
  //     this.selectedFileLogo = null; // Resetar selectedFile se nenhum arquivo for selecionado
  //     this.logoPreviewUrl = null;
  //   }
  // }
  erroTamanhoImagem2: boolean = false;
  erroTipoImagem2: boolean = false;
  onFaviconSelect(event: any): void {

    this.form2 = true;
    this.erroTamanhoImagem2 = false;
    this.erroTipoImagem2 = false;
    if (event.files && event.files.length > 0) {
      this.selectedFileFavicon = event.files[0]; // Atribuir o arquivo selecionado à variável selectedFile

      // Verificar o tamanho do arquivo (máximo 1MB)
      if (this.selectedFileFavicon && this.selectedFileFavicon.size > 1048576) {
        this.erroTamanhoImagem2 = true;
        this.selectedFileFavicon = null;
        this.faviconPreviewUrl = false;
        return;
      }

      // Verificar o tipo do arquivo (webp, png, jpg, jpeg)
      const fileType = this.selectedFileFavicon?.type;
      if (fileType && !['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'].includes(fileType)) {
        this.erroTipoImagem2 = true;
        this.selectedFileFavicon = null;
        this.faviconPreviewUrl = false;
        return;
      }


      if (this.selectedFileFavicon) { // Verifica se realmente existe um arquivo antes de prosseguir
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.faviconPreviewUrl = e.target.result; // Atribui a URL da imagem para visualização
          this.checkSaveBtn();
          this.form2 = true;
          this.displaySidebar = true;

        };
        //this.toggleSidebar();
        reader.readAsDataURL(this.selectedFileFavicon);
      }
    } else {
      this.selectedFileFavicon = null; // Resetar selectedFile se nenhum arquivo for selecionado
      this.faviconPreviewUrl = null;
    }
  }




  checkSaveBtn() {
    if (this.errorName == false) {
      this.btnSave = false;
    } else {
      this.form2 = false;
      this.form1 = false;
      this.form3 = false;
    }
  }

  updatePrimaryColor(value: string | object): void { // formToSave2 displaySidebar
    const color = typeof value === 'string' ? value : '';
    this.checkSaveBtn();
    this.form2 = true;
  }
  updateSecondaryColor(value: string | object): void { // formToSave2 displaySidebar
    const color = typeof value === 'string' ? value : '';
    this.checkSaveBtn();
    this.form2 = true;
  }
  formToSave2() {
    this.displaySidebar = true;
    setTimeout(() => {
      this.manageOverlay();
    }, 1);
    this.form2 = true;
    this.btnSave = false;
  }
  allowOnlyNumbers(event: KeyboardEvent) {
    // Permite apenas dígitos numéricos
    if (!/[0-9]/.test(event.key)) {
      event.preventDefault();
    }
  }
  mask: string = '0000-0000';
  mask2: string = '0000-0000||00000-0000';
  updateMask(value: string) {
    if (value && value.length <= 9) { // Adapte este número ao ponto de transição entre as máscaras
      this.mask = '00000-000'; // Máscara para números com 8 dígitos após o DDD
    } else {
      this.mask = '00000-0000'; // Máscara para números com 9 dígitos após o DDD
    }
    //this.form1 = true;
  }
  limitInput(event: any) {
    const value = event.target.value;
    if (value.length > 2) {
      event.target.value = value.slice(0, 2);
      // Atualize o valor no seu modelo, se necessário
      // Isso pode ser necessário porque a atualização direta do valor do input
      // pode não refletir automaticamente no modelo Angular.
    }
  }
  preventE(event: KeyboardEvent) {
    if (event.key === 'e' || event.key === 'E') {
      event.preventDefault();
    }
  }

  showSlickClearFunction() {
    if (this.valuesDoms && this.valuesDoms?.length > 0) {
      this.showClearDoms = true;
    } else {
      this.showClearDoms = false;
    }
  }
  showClearDoms: boolean = false;
  clearSlickMaps() {
    this.valuesDoms = [];
    this.showClearDoms = false;
    this.displaySidebar = true;
    this.btnSave = false;
    this.form2 = true;

  }
  showErrorDialog(message: string) {
    this.confirmationService.confirm({
      message: message,
      header: 'Erro',
      icon: 'pi pi-times',
      accept: () => {
        // Lógica de aceitação, se necessário
      }
    });
  }

  form1: boolean = false;
  form2: boolean = false;
  form3: boolean = false;
  checkInput() {
    this.errorName = this.storeName.trim().length === 0;
    if (this.errorName) {
      this.btnSave = true;
      this.displaySidebar = false;
      this.form1 = false;
    } else {
      this.btnSave = false;
    }
  }
  formToSave1() { // removelogo checkInput
    this.displaySidebar = true;
    setTimeout(() => {
      this.manageOverlay();
    }, 1);
    this.form1 = true;
    this.btnSave = false;
  }


  checkCEP() {
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.configService.checkCEP2(this.zipcode).subscribe({
        next: (resp) => {
          if (resp) {
            this.address = resp.logradouro;
            this.neighborhood = resp.bairro;
            this.complement = resp.complemento;
            this.city = resp.localidade;
            this.selectedState = { label: resp.uf || 'SP', value: resp.uf || 'SP' };;
          }
        },
        error: (error) => {

        }
      });
    }, 750);
  }

  private debounceTimer: any = null;
  formToSave3() {

    this.errorURL = false;
    clearTimeout(this.debounceTimer);
    clearTimeout(this.debounceTimer);
    this.debounceTimer = setTimeout(() => {
      this.configService.verificarDisponibilidadeSubdominio(this.urlStore).subscribe({
        next: (res: any) => {
          if (res.message == "Não existe Loja com o subdomínio informado.") {
            this.form3 = true;
            this.btnSave = false;
            this.displaySidebar = true;
            setTimeout(() => {
              this.manageOverlay();
            }, 1);
          }


        },
        error: (error: any) => {
          this.displaySidebar = false;
          this.urlStore = this.urlStoreBefore;
          this.form3 = false;
          this.errorURL = true;
          this.btnSave = true;
          let message = '';
          this.saveBtnForm = false;
          this.btnSave = true;
          console.error('Error response', error);
          if (error.status === 400 || error.status === 403 || error.status === 401) {
            //message = error.error.message;
            this.message = error.error.message;
          } else if (error.status === 500) {
            //message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
            this.message = "Ops... Algo de errado aconteceu. Tente novamente mais tarde.";
          } else if (error.status !== 404) {
            message = error.error.message;
          }

          // if (message) {
          //   this.showErrorDialog(message);
          // }
        }
      });
    }, 750);

  }
  message: string = "";
  errorURL: boolean = false;
  errorName: boolean = false;
  // novo upload
  fileUploadIsValid = true;
  selectedFile: File | null = null;

  handleManualFileUpload(file: File): void {
    this.onLogoSelect({ files: [file] });
  }

  handleFileInvalid(reason: string) {
    this.fileUploadIsValid = false;
    if (reason === 'size') this.erroTamanhoImagem = true;
    if (reason === 'type') this.erroTipoImagem = true;
    //this.disableSave = true;
  }

  handleFileValid() {
    this.erroTamanhoImagem = false;
    this.erroTipoImagem = false;
    this.fileUploadIsValid = true;
    //this.disableSave = !this.fileUploadIsValid || this.errorName;
  }
  removelogo(): void {
    this.displaySidebar = true;
    setTimeout(() => {
      this.manageOverlay();
    }, 1);
    this.logoPreviewUrl = null;
    this.selectedFileLogo = null;
    this.form2 = true;
    this.checkSaveBtn();
  }
  // novo upload
  handleManualFaviconUpload(file: File): void {
    this.onFaviconSelect({ files: [file] });
  }

  handleFileInvalid2(reason: string) {
    if (reason === 'size') this.erroTamanhoImagem2 = true;
    if (reason === 'type') this.erroTipoImagem2 = true;
  }

  handleFileValid2() {
    this.erroTamanhoImagem2 = false;
    this.erroTipoImagem2 = false;
  }

  removelogoFavicon(): void {
    this.displaySidebar = true;
    setTimeout(() => {
      this.manageOverlay();
    }, 1);
    this.faviconPreviewUrl = null;
    this.selectedFileFavicon = null;
    this.form2 = true;
    this.checkSaveBtn();
  }
  // novo upload

  // States do wallpaper
  selectedFileWallpaper: File | null = null;
  wallpaperPreviewUrl: string | null = null;
  erroTamanhoImagemWallpaper = false;
  erroTipoImagemWallpaper = false;
  hasWallpaperTmp = false;
  wallpaperTmp: string | null = null;

  handleManualWallpaperUpload(file: File): void {
    this.onWallpaperSelect({ files: [file] });
  }

  onWallpaperSelect(event: any): void {
    this.erroTamanhoImagemWallpaper = false;
    this.erroTipoImagemWallpaper = false;

    if (event.files && event.files.length > 0) {
      this.selectedFileWallpaper = event.files[0];

      // Máx 1MB
      if (this.selectedFileWallpaper && this.selectedFileWallpaper.size > 1048576) {
        this.erroTamanhoImagemWallpaper = true;
        this.selectedFileWallpaper = null;
        this.wallpaperPreviewUrl = null; // <-- era false
        return;
      }

      // Tipos permitidos
      const fileType = this.selectedFileWallpaper?.type;
      if (fileType && !['image/webp', 'image/png', 'image/jpg', 'image/jpeg', 'image/avif'].includes(fileType)) {
        this.erroTipoImagemWallpaper = true;
        this.selectedFileWallpaper = null;
        this.wallpaperPreviewUrl = null; // <-- era false
        return;
      }

      if (this.selectedFileWallpaper) {
        const reader = new FileReader();
        reader.onload = (e: any) => {
          this.wallpaperPreviewUrl = e.target.result as string;
          this.checkSaveBtn?.();
          this.form2 = true;
          this.displaySidebar = true;
        };
        reader.readAsDataURL(this.selectedFileWallpaper);
      }
    } else {
      this.selectedFileWallpaper = null;
      this.wallpaperPreviewUrl = null;
    }
  }


  removeWallpaper(): void {
    this.displaySidebar = true;
    setTimeout(() => {
      this.manageOverlay();
    }, 1);
    this.selectedFileWallpaper = null;
    this.wallpaperPreviewUrl = null;
    this.form2 = true;
    this.erroTamanhoImagemWallpaper = false;
    this.erroTipoImagemWallpaper = false;
    this.checkSaveBtn();
  }

  // <<< aqui aceita string para casar com o Output do filho
  handleFileInvalidWallpaper(reason: string): void {
    this.erroTamanhoImagemWallpaper = (reason === 'size');
    this.erroTipoImagemWallpaper = (reason === 'type');
  }

  handleFileValidWallpaper(): void {
    this.erroTamanhoImagemWallpaper = false;
    this.erroTipoImagemWallpaper = false;
  }


}
